import React, { ReactNode } from "react";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import classNames from "classnames";
import BootstrapDialog from "components/BootstrapDialog";
import ButtonCustom from "components/ButtonCustom";
import { makeStyles } from "@mui/styles";

type CrudModalProps = {
  cancelBtnLabel: string;
  children: React.ReactNode;
  contentClassName: string;
  dialogProps: any;
  formTitle: string | ReactNode;
  handleClose: (params?: any) => void;
  handleSave: (params?: any) => void;
  handleSaveDraft: (params?: any) => void;
  isOpen: boolean;
  moreActions: React.ReactNode;
  saveBtnLabel: string;
  saveDraftBtnLabel: string;
  saveBtnColor:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | undefined;
  loading: boolean;
  isDisabledSaveBtn: boolean;
  width?: number | string;
  maxWidth?: number | string;
  isDisabledPadding?: boolean;
  hasDivider?: boolean;
  changeBackground?: string;
};
const useStyles = makeStyles({
  btn: {
    borderRadius: "4px !important",
    minWidth: "90px !important",
    fontSize: "14px !important",
    fontWeight: 500,
  },
});
function CrudModal(props: Partial<CrudModalProps>) {
  const classes = useStyles();
  const {
    isOpen,
    handleClose,
    handleSave,
    cancelBtnLabel,
    saveBtnLabel,
    saveBtnColor = "success",
    formTitle,
    children,
    dialogProps,
    contentClassName,
    moreActions,
    handleSaveDraft,
    saveDraftBtnLabel,
    loading = false,
    isDisabledSaveBtn,
    width,
    isDisabledPadding,
    hasDivider = true,
    changeBackground,
    maxWidth
  } = props;
  return (
    <BootstrapDialog
      isOpen={isOpen}
      width={width}
      maxWidth={maxWidth}
      formTitle={formTitle}
      handleClose={handleClose}
      changeBackground={changeBackground}
      {...dialogProps}
    >
      <DialogContent
        dividers={hasDivider}
        className={classNames(contentClassName)}
        sx={{ padding: isDisabledPadding ? "0px !important" : "0 16px" }}
      >
        {children}
      </DialogContent>
      <DialogActions sx={{ px: "16px !important", backgroundColor: changeBackground }}>
        {moreActions}
        <ButtonCustom
          color="info"
          onClick={handleClose}
          disabled={loading}
          sx={{ fontSize: 14, backgroundColor: '#fff' , '&:hover' : {backgroundColor: '#fff !important'}}}
        >
          {cancelBtnLabel}
        </ButtonCustom>
        {handleSaveDraft && (
          <ButtonCustom
            color="warning"
            classes={{ root: classes.btn }}
            onClick={handleSaveDraft}
            loading={loading || false}
          >
            {saveDraftBtnLabel}
          </ButtonCustom>
        )}
        {handleSave && (
          <ButtonCustom
            color={saveBtnColor}
            classes={{ root: classes.btn }}
            onClick={handleSave}
            loading={loading || false}
            disabled={isDisabledSaveBtn}
          >
            {saveBtnLabel}
          </ButtonCustom>
        )}
      </DialogActions>
    </BootstrapDialog>
  );
}

CrudModal.defaultProps = {
  cancelBtnLabel: "Close",
  saveBtnLabel: "Save",
  saveDraftBtnLabel: "Save draft",
  saveBtnColor: "success",
  changeBackground: '#fff'
};

export default CrudModal;
